export default {
  nome: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  username: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  password: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  tipoUsuario: {
    value: null,
    required: false,
    state: null
  },
  paId: {
    value: null,
    required: false,
    state: null
  },
  mesasIds: {
    value: [],
    required: false,
    state: null
  },
  midias: {
    value: [],
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/nxSenhas/tv/components/add/tv-form.js